import { DrugFoodInteraction } from "domain/entities/drug-food-interaction";
import { Result } from "domain/entities/result";
import { DrugFoodInteractionRepository } from "domain/repositories";

export default class UpdateUseCase {
    private drugFoodInteractionRepository: DrugFoodInteractionRepository;
    
    public constructor(drugFoodInteractionRepository: DrugFoodInteractionRepository) {
        this.drugFoodInteractionRepository = drugFoodInteractionRepository
    }

    public async updateDrugFoodInteraction(id: number, drugFoodInteraction: DrugFoodInteraction, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugFoodInteractionRepository.updateDrugFoodInteraction(id, drugFoodInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}